var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowLeftNoFill = function SvgArrowLeftNoFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 14,
    viewBox: "0 0 8 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.687 12.045 2.574 6.933l5.113-5.112A1.065 1.065 0 1 0 6.18.312L.313 6.18a1.064 1.064 0 0 0 0 1.508l5.867 5.867a1.065 1.065 0 1 0 1.507-1.508"
  })));
};
export default SvgArrowLeftNoFill;